module.exports = __webpack_public_path__ + "img/littleImg01.0fdc1d6d.gif";